import sessionStorage from '@/utils/storage/sessionStorage';

const state = {
  goodsCount: sessionStorage.get('goodsCount')
    ? sessionStorage.get('goodsCount')
    : 0
};

const getters = {};

const mutations = {
  setCount(state, count) {
    state.goodsCount = count.params;
    // 同时本地存储
    sessionStorage.set('goodsCount', count.params);
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
